// tslint:disable no-import-side-effect
// tslint:disable no-submodule-imports
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'tslib';

import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import './styles/index.css';

import App from './App';

// import i18n (needs to be bundled ;))
import './i18n/i18n';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
serviceWorker.register();



// WEBPACK FOOTER //
// ./src/index.tsx